import { DataTable, type DataTableProps, type TableRow } from "@carbon6/c6-frontend-design";
import { useTableStateMessages } from "./tableStateMessages";

// 앱 전체 표가 공유하는 행 높이 하한. Dataset 목록의 섬네일 행 높이를 기준으로 한다.
// 그래서 페이지 사이의 행 리듬이 같다. c6 가 .row 를 border-box 로 고정한다. 그래서 이 값은
// 보더 1px 을 포함한다.
export const HAT_DATA_TABLE_ROW_MIN_HEIGHT = "46px";

// 실패 자리는 이 표가 소유한다. 호출부는 넘기지 않는다.
type HatDataTableProps<Row extends TableRow> = Omit<DataTableProps<Row>, "errorMessage">;

/**
 * 앱 기본 행 리듬과 빈·대기·실패 형태를 입힌 c6 `DataTable`.
 *
 * c6 는 행 높이 하한을 전역 CSS 변수가 아니라 표 단위 prop(`rowMinHeight`)으로 받는다.
 * 커스텀 프로퍼티는 상속되어 중첩 표에도 적용된다. 그래서 한 표만 예외로 두기 어렵다.
 * 앱의 표는 같은 리듬을 써야 한다. 그래서 기본값을 이 파일 한 곳에 둔다. 새 표가 값을
 * 전달하지 않아도 리듬이 같다. 특정 표만 다른 하한이 필요하면 `rowMinHeight` 로 덮어쓴다.
 *
 * 빈 상태·대기·조회 실패의 형태도 이 표가 소유한다(`useTableStateMessages`, docs/rules.md §19).
 * 호출부는 `emptyMessage`·`loadingMessage` 에 문장만 넘긴다.
 */
export function HatDataTable<Row extends TableRow>({
  rowMinHeight = HAT_DATA_TABLE_ROW_MIN_HEIGHT,
  emptyMessage,
  loadingMessage,
  ...props
}: HatDataTableProps<Row>) {
  const stateMessages = useTableStateMessages(props.source, { emptyMessage, loadingMessage });
  return <DataTable {...props} {...stateMessages} rowMinHeight={rowMinHeight} />;
}
